import { useEffect } from "react";
import Decimal from "decimal.js";
import { useTranslation } from "react-i18next";
import { Button } from "@crashx/ui";
import type { MyBet } from "@crashx/shared";
import { useRoundStore } from "../../state/roundStore.js";
import { useNotificationStore } from "./notificationStore.js";
export function BetToast({ bet }: { bet: MyBet }) {
  const { t } = useTranslation();
  const decimals = useRoundStore(
    (state) => state.config?.currencies.find((currency) => currency.code === bet.currency)?.decimals ?? 2,
  );
  useEffect(() => {
    const timer = setTimeout(() => useNotificationStore.getState().dismiss(bet.betId), 6000);
    return () => clearTimeout(timer);
  }, [bet.betId]);
  return (
    <div
      className="cx-toast"
      role="status"
      style={{ borderColor: bet.status === "won" ? "var(--cx-color-success)" : "var(--cx-color-danger)" }}
    >
      <div>
        <strong>{t("bet.panel", { panel: bet.panel })}</strong>
        <p className="m-0 text-sm">
          {t(bet.status === "won" ? "bet.won" : "bet.lost", {
            amount: new Decimal(bet.status === "won" ? (bet.win ?? 0) : bet.amount).toFixed(decimals),
            currency: bet.currency,
            multiplier: bet.multiplier?.toFixed(2),
          })}
        </p>
      </div>
      <Button
        variant="ghost"
        aria-label={t("notifications.dismiss")}
        onClick={() => useNotificationStore.getState().dismiss(bet.betId)}
      >
        {t("notifications.close")}
      </Button>
    </div>
  );
}
